import React from "react";

import { ExpandMoreRounded } from "@mui/icons-material";
import { Box, Collapse, Divider } from "@mui/material";

import useAuth from "../../../../config/context/authContext";
import useFirebase from "../../../../config/context/firebaseContext";
import useModal from "../../../../config/context/modalContext";
import { DataBaseObjectType, MainIndexDB } from "../../../../config/mainIndexDB";
import storageKey from "../../../../config/storageKey";
import { GreyPallet } from "../../../../config/styles";

import ExpandMore from "../../../../components/ExpandMore";
import SwitchMain from "../../../../components/InputMain/SwitchMain";
import MainText from "../../../../components/MainText";

export default function SystemConfig() {
  const { currentUserState } = useAuth();

  const { functions } = useFirebase();
  const { pushAlert } = useModal();

  const [systemLog, setSystemLog] = React.useState(
    window.localStorage.getItem(storageKey.SHOW_LOG) ? true : false
  );

  const [logData, setLogData] = React.useState<DataBaseObjectType[]>([]);

  const [showLogBox, setShowLogBox] = React.useState(false);

  const handleChangeSystemLog = (value: boolean) => {
    if (value) {
      window.localStorage.setItem(storageKey.SHOW_LOG, "true");
    } else {
      window.localStorage.removeItem(storageKey.SHOW_LOG);
    }

    setSystemLog(value);
  };

  const handleGetLogData = async () => {
    const retrievedData = await MainIndexDB.retrieveAllStore("app-log");
    setLogData(retrievedData);
  };

  React.useEffect(() => {
    handleGetLogData();
  }, []);

  return (
    <Box mt={3}>
      <MainText size="subtitle">Sistema</MainText>

      <Box mt={2}>
        <SwitchMain name="Log do Sistema" checked={systemLog} onChange={handleChangeSystemLog} />
      </Box>

      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        sx={{ backgroundColor: GreyPallet.Light, borderRadius: "15px" }}
        px={2}
        py={1}
        mb={1}
      >
        <MainText color="regular">Exibir Log</MainText>

        <ExpandMore
          expand={showLogBox}
          onClick={() => setShowLogBox(!showLogBox)}
          aria-expanded={showLogBox}
        >
          <ExpandMoreRounded />
        </ExpandMore>
      </Box>

      <Collapse
        in={showLogBox}
        timeout="auto"
        unmountOnExit
        sx={{ backgroundColor: GreyPallet.Light, borderRadius: "15px", overflow: "hidden" }}
      >
        <Box p={2}>
          {logData.length ? (
            logData.map((item: any, logIndex: number) => {
              let customStyle: { [key: string]: string } = {};
              item.value.content.style.split(";").map((style: string) => {
                const splitedStyle = style.split(":");
                const identifier = splitedStyle[0];
                customStyle[identifier] = splitedStyle[1];
              });
              (customStyle as any).fontSize = 14;

              return (
                <Box key={logIndex}>
                  <Box style={customStyle}>
                    {typeof item.value.content === "object"
                      ? String(item.value.content.title)
                      : null}
                  </Box>

                  {item.value.content.args.map((arg: any, argIndex: number) => (
                    <Box mt={1} key={argIndex}>
                      <MainText size="small" color="regular">
                        {String(arg)}
                      </MainText>
                    </Box>
                  ))}

                  {logIndex + 1 < logData.length && <Divider sx={{ my: 1 }} />}
                </Box>
              );
            })
          ) : (
            <MainText color="regular">Nenhum log disponível</MainText>
          )}
        </Box>
      </Collapse>
    </Box>
  );
}
